import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxNavigationWithDataComponent } from 'ngx-navigation-with-data';
import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { FakeBackendProvider } from './core/helpers/fake-backend';
import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataTablesModule} from 'angular-datatables';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { UiSwitchModule } from 'ngx-ui-switch';
import { AgmCoreModule } from '@agm/core';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators'; 
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ChartsModule, ThemeService } from 'ng2-charts';

// Perfect Scroll bar
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	wheelSpeed: 0.5,
	swipeEasing: true,
	minScrollbarLength: 40,
	maxScrollbarLength: 300,	
};
//import { FullCalendarModule } from 'plugins/@fullcalendar/angular';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LayoutsModule,
    AppRoutingModule,
    DataTablesModule,
    AgmCoreModule.forRoot({
			apiKey: 'AIzaSyCOU3JJt7VndsiYn0y1y0putI58N1YjQZs',
			libraries: ["places"]
		}),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),    
    UiSwitchModule,
    
    RxReactiveFormsModule

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    NgxNavigationWithDataComponent,
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    // provider used to create fake backend
    FakeBackendProvider,
    ThemeService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
